import * as actionTypes from "./actionTypes";
import axios from "../../util/axios-reportonce";
import serverSelect from "../../serverSelect";

export const loadListingDashboardStart = (ekey) => {
    return {
        type: actionTypes.LOAD_LISTING_DASHBOARD_START,
        ekey: ekey,
    };
};

export const loadListingDashboardSuccess = (data) => {
    return {
        type: actionTypes.LOAD_LISTING_DASHBOARD_SUCCESS,
        data: data,
    };
};

export const loadListingDashboardFail = (errorMessage, errorCode) => {
    return {
        type: actionTypes.LOAD_LISTING_DASHBOARD_FAIL,
        errorMessage: errorMessage,
        errorCode: errorCode,
    };
};

export const loadListingDashboard = (ekey) => {
    return (dispatch, getState) => {
        // Dashboard is public so auth header is not requred
        dispatch(loadListingDashboardStart(ekey));
        const server = serverSelect();
        axios
            .get(`${server}/api/dashboard/${ekey}`)
            .then(function (response) {
                dispatch(loadListingDashboardSuccess(response.data));
            })
            .catch(function (error) {
                let errorMessage = error.toString();
                if (
                    error.response &&
                    error.response.data &&
                    error.response.data.detail
                ) {
                    // .response doesn't always exist, so always double check before trying to use anything passed in the response.
                    errorMessage = error.response.data.detail;
                }
                let errorCode = false;
                if (error.response && error.response.status) {
                    // .response doesn't always exist, so always double check before trying to use anything passed in the response.
                    errorCode = error.response.status;
                }
                dispatch(loadListingDashboardFail(errorMessage, errorCode));
            })
            .then(function () {
                // always executed
            });
    };
};